import { useSetAtom } from "jotai";
import { useCallback } from "react";
import { useOpenVisitorModalCallback } from "../../modals/useOpenVisitorModalCallback";
import { videoRoomTokenAtom } from "../../../video-sdk/core/room/state";
import { useAtomCallback } from "jotai/utils";
import { isAdmissionModalOpenAtom } from "./state";
import { useResetFaviconAndTitleCallback } from "../useResetFaviconAndTitleCallback";
import { useTranslate } from "@growtherapy/i18n";

export function useClearAdmissionStateCallback() {
  const t = useTranslate();
  const setVideoRoomToken = useSetAtom(videoRoomTokenAtom);
  const openVisitorModal = useOpenVisitorModalCallback();
  const getIsAdmissionModalOpen = useAtomCallback(
    useCallback((get) => get(isAdmissionModalOpenAtom), []),
  );
  const resetFaviconAndTitleCallback = useResetFaviconAndTitleCallback();

  return useCallback(() => {
    setVideoRoomToken(undefined);
    if (getIsAdmissionModalOpen()) {
      openVisitorModal(null);
    }
    if (document.title === t("telehealth-core:meta.joinYourSession")) {
      resetFaviconAndTitleCallback();
    }
  }, [
    t,
    setVideoRoomToken,
    getIsAdmissionModalOpen,
    openVisitorModal,
    resetFaviconAndTitleCallback,
  ]);
}
